"use client";

import dynamic from "next/dynamic";

const AttributionInitializer = dynamic(
  () => import("@/components/analytics/AttributionInitializer").then((mod) => mod.AttributionInitializer),
  { ssr: false },
);
const ScrollDepthTracker = dynamic(
  () => import("@/components/analytics/ScrollDepthTracker").then((mod) => mod.ScrollDepthTracker),
  { ssr: false },
);
const GA4PageView = dynamic(
  () => import("@/components/analytics/GA4PageView").then((mod) => mod.GA4PageView),
  { ssr: false },
);
const GA4ConsentSync = dynamic(
  () => import("@/components/analytics/GA4ConsentSync").then((mod) => mod.GA4ConsentSync),
  { ssr: false },
);
const ServiceWorkerRegister = dynamic(
  () => import("@/components/pwa/ServiceWorkerRegister.client").then((mod) => mod.ServiceWorkerRegister),
  { ssr: false },
);

const PublicWebMCP = dynamic(
  () => import("@/components/agents/PublicWebMCP.client").then((mod) => mod.PublicWebMCP),
  { ssr: false },
);

type LayoutEnhancementsProps = {
  enableGa4: boolean;
  isAdminShellRequest: boolean;
  serviceWorkerScriptUrl: string;
};

export function LayoutEnhancements({
  enableGa4,
  isAdminShellRequest,
  serviceWorkerScriptUrl,
}: LayoutEnhancementsProps) {
  return (
    <>
      {!isAdminShellRequest ? (
        <>
          <PublicWebMCP />
          <AttributionInitializer />
          <ScrollDepthTracker />
          <GA4ConsentSync enabled={enableGa4} />
          <GA4PageView enabled={enableGa4} />
        </>
      ) : null}
      <ServiceWorkerRegister scriptUrl={serviceWorkerScriptUrl} scope="/" />
    </>
  );
}
